import React from 'react'
import useStyles from './styled'

const ChatContent = (props) => {
  const { liveId } = props
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <iframe
        frameBorder="0"
        src={`https://vimeo.com/live-chat/${liveId}`}
        height="100%"
        width="100%"
      />
    </div>
  )
}

export default ChatContent
